import Icon from 'veui/components/Icon'
import { IconSortDesc } from 'dls-icons-vue'

Icon.register('sort-desc', IconSortDesc)
